import axios from 'axios'
const home = `https://members.eccourts.org/`

export default {
notify (data, id) {
  let formData = new FormData()
  formData.append('email',data.email)
  formData.append('appname',data.appname)
  formData.append('application', data.application)
  formData.append('status', data.status)
  let config = {
    headers: {
      'Content-Type': undefined,
      'Accept': 'application/json, text/javascript, */*;q=0.01'
    }
  }
  return axios.post(`${home}/wp-json/contact-form-7/v1/contact-forms/${id}/feedback/`, formData, config)
},
newRecord(data){
  let formData = new FormData()
  formData.append('from',data.from)
  formData.append('to',data.to)
  formData.append('record', data.record)
  formData.append('routeuser', data.routeuser)
  formData.append('message', data.message)
  formData.append('url', data.url)
  formData.append('_wpcf7_unit_tag', '25142e8')
  let config = {
    headers: {
      'Content-Type': undefined,
      'Accept': 'application/json, text/javascript, */*;q=0.01'
    }
  }
  return axios.post(`${home}/wp-json/contact-form-7/v1/contact-forms/${528}/feedback/`, formData, config)
},
newRequest(data, id){
  let uid = id ? id : 3437
  let formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })

  let config = {
    headers: {
      'Content-Type': undefined,
      'Accept': 'application/json, text/javascript, */*;q=0.01'
    }
  }
  return axios.post(`${home}/wp-json/contact-form-7/v1/contact-forms/${uid}/feedback/`, formData, config)
}
}

